<div class="flex-row">
    <label for="precision">Precision</label>
    <input id="precision" type="number" [(ngModel)]="data.arguments.precision" />
    <div class="checkbox">
        <input id="enforcePrec" class="show-for-sr" type="checkbox" [(ngModel)]="data.arguments.enforcePrecision">
        <label for="enforcePrec">
            Always show precision
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
                <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
        </label>
    </div>
    <label for="defaultValue">Default Value</label>
    <input id="defaultValue" type="number" [(ngModel)]="data.arguments.defaultValue" />
</div>
